export default "__VITE_ASSET__DEP9mbHP__"